const dictionary = {
  comCobranca: 'Com Cobranças à vista',
  outrasCobrancas: 'Com outras Cobranças Vencidas',
  qtdDias: 'Quant. de dias',
  maisVeiculos: 'Possui mais de um veículo Ativo',
};

export function translateDictionary(value) {
  const objKeys = Object.keys(value);
  let variaveis = '';

  objKeys.forEach((element) => {
    const legenda = dictionary[element] || element;
    variaveis += `${variaveis == '' ? '' : ', '}${legenda} = ${value[element]}`;
  });

  return variaveis;
}
